export default __webpack_public_path__ + "static/media/eraser.9bf53831.cur";